// Vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import cn from 'classnames';
// Helpers
import { post } from 'helpers/api';
import getAuthKey from 'helpers/getAuthKey';
// Components
import AppLink from '../../components/AppLink';
import { FacebookProvider, CommentsCount } from 'react-facebook';
// Root Styles
import '../../styles/document.styl';
// Styles
import './style.styl';

class EntryCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      likesCounterGlobal: this.props.entry.likes || 0,
      likesCounterLocal: this.props.entry.user_likes || 0,
    };
  }

  handleLike = e => {
    e.preventDefault();

    const { likesCounterGlobal, likesCounterLocal } = this.state;
    const { entry } = this.props;

    if (!this.likeTimeout) {
      this.setState(
        {
          likesCounterGlobal: 1 + parseInt(likesCounterGlobal),
          likesCounterLocal: 1 + parseInt(likesCounterLocal),
        },
        () => {
          const data = { user_likes: this.state.likesCounterLocal };
          post(`/insight/${entry.id}/like`, {
            data: data,
            headers: { Authorization: `Bearer ${getAuthKey()}` },
            before: () => {
              this.setState({
                isSending: true,
              });
            },
            success: data => {
              this.setState({
                isSending: false,
              });
            },
            error: err => {
              // const errorMsg = getErrorMessage(err);
              console.log('Error with user like', err);
              this.setState({
                isSending: false,
                // error: this.serverErrorsMap[errorMsg] || errorMsg,
                error: err,
                errorMessage: err.message,
              });
            },
          });

          this.setLikeTimeout();
        },
      );
    }
  };

  setLikeTimeout = () => {
    this.likeTimeout = true;

    setTimeout(() => {
      this.likeTimeout = false;
    }, 1000);
  };

  likeTimeout = false;

  render() {
    const {
      entry: {
        id,
        result,
        date,
        product,
        title,
        avatar,
        author,
        author_id,
        position,
        company,
        likes,
        views,
      },
      isUser,
    } = this.props;
    const { likesCounterGlobal, likesCounterLocal, likesNotificationsArray } = this.state;
    const resultClass = cn('EntryCard__result', `EntryCard__result_${result}`);
    const avatarSrc = avatar && avatar != 'null' ? avatar : '/static/images/icons/avatar.svg';

    return (
      <div className="EntryCard">
        <div className="EntryCard__content">
          <div className="EntryCard__header">
            <div className={resultClass} />
          </div>

          <div className="EntryCard__product">{product}</div>

          <div className="EntryCard__title">
            <p>{ReactHtmlParser(title)}</p>
          </div>

          <div className="EntryCard__counters">
            {/* {isUser ? (
              <button
                type="button"
                className="EntryCard__counter EntryCard__counter_likes"
                onClick={this.handleLike}>
                {likesCounterGlobal || 0}
              </button>
            ) : (
              <AppLink href={`/login`} className="EntryCard__counter EntryCard__counter_likes">
                {likesCounterGlobal || 0}
              </AppLink>
            )} */}
            <div className="EntryCard__counter EntryCard__counter_views">{views || 0}</div>
            {false && (
              <div className="EntryCard__counter EntryCard__counter_comments">
                <FacebookProvider appId="2300407050031490">
                  <CommentsCount href={`https://beztz.net/insight-${id}`} />
                </FacebookProvider>
              </div>
            )}
          </div>

          <div className="EntryCard__footer">
            <AppLink href={`/user-${author_id}`} className="EntryCard__author">
              <div className="EntryCard__author-aside">
                <img className="EntryCard__author-img" src={avatarSrc} />
              </div>
              <div className="EntryCard__author-body">
                <div className="EntryCard__author-name">{author}</div>
                <div className="EntryCard__author-position">
                  {position}
                  {position && company && ' в '}
                  {company}
                </div>
              </div>
            </AppLink>
          </div>

          <AppLink href={`/insight-${id}`} className="EntryCard__link" />
        </div>
      </div>
    );
  }
}

EntryCard.defaultProps = {
  entry: {},
};

EntryCard.propTypes = {
  entry: PropTypes.object,
};

export default EntryCard;



// WEBPACK FOOTER //
// components/EntryCard/index.js